import React, { useState } from 'react';

import MovieCard from './MovieCard';

import './App.css';
import searchIcon from './search.svg';

// const API_URL = 'http://www.omdbapi.com/?i=tt3896198&apikey=a69df72f';

const App = () => {
  const [movies, setMovies] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');

  const searchMovies = async (title) => {
    // const response = await fetch(`${API_URL}&s=${title}`);
    const response = await fetch(
      `http://www.omdbapi.com/?i=tt3896198&apikey=a69df72f&s=${title}`
    );
    const data = await response.json();

    setMovies(data.Search);
  };

  // useEffect(() => {
  //   searchMovies("Spiderman");
  // }, []);

  return (
    <div className="app">
      <h1>MovieLand</h1>

      <div className="search">
        <input
          placeholder="Search for movies"
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
        />
        <img
          src={searchIcon}
          alt="Search"
          onClick={() => searchMovies(searchTerm)}
        />
      </div>

      {movies?.length > 0 ? (
        <div className="container">
          {movies.map((movie) => (
            <MovieCard movie={movie} />
          ))}
        </div>
      ) : (
        <div className="empty">
          <h2>No movies found</h2>
        </div>
      )}
    </div>
  );
};

export default App;
